import { UserManagementActionType } from './actions';
import { MerchantUsersResponse } from './interfaces';
import { ErrorAPI } from '../interfaces';

export interface UserManagementState {
  loading: boolean;
  error: boolean;
  errorInfo: ErrorAPI | null;
  allMerchantUsers: MerchantUsersResponse | null;
  deleteSuccess: boolean;
  restoreSuccess: boolean;
  swapOwnerSuccess: boolean;
  resendInviteSuccess: boolean;
  inviteLoading: boolean;
  inviteError: boolean;
  inviteErrorInfo: ErrorAPI | null;
}

const initialState: UserManagementState = {
  loading: false,
  error: false,
  errorInfo: null,
  allMerchantUsers: null,
  deleteSuccess: false,
  restoreSuccess: false,
  swapOwnerSuccess: false,
  resendInviteSuccess: false,
  inviteLoading: false,
  inviteError: false,
  inviteErrorInfo: null,
};

export const userManagementReducer = (state = initialState, action: any): UserManagementState => {
  switch (action.type) {
    case UserManagementActionType.GET_MERCHANT_USERS:
      return {
        ...state,
        loading: true,
        error: false,
        errorInfo: null,
      };
    case UserManagementActionType.GET_MERCHANT_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        allMerchantUsers: action.response,
      };
    case UserManagementActionType.GET_MERCHANT_USERS_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        errorInfo: action.error,
      };
    case UserManagementActionType.DELETE_MERCHANT_USER:
      return {
        ...state,
        loading: true,
        error: false,
        deleteSuccess: false,
      };
    case UserManagementActionType.DELETE_MERCHANT_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSuccess: true,
        allMerchantUsers: state.allMerchantUsers
          ? {
              ...state.allMerchantUsers,
              outdated: true,
            }
          : null,
      };
    case UserManagementActionType.DELETE_MERCHANT_USER_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        errorInfo: action.error,
        deleteSuccess: false,
      };
    case UserManagementActionType.CLEAN_ERROR:
      return {
        ...state,
        error: false,
        errorInfo: null,
        inviteError: false,
        inviteErrorInfo: null,
        deleteSuccess: false,
        swapOwnerSuccess: false,
        restoreSuccess: false,
        resendInviteSuccess: false,
      };
    case UserManagementActionType.SWAP_OWNER_ROLE:
      return {
        ...state,
        loading: true,
        error: false,
        swapOwnerSuccess: false,
      };
    case UserManagementActionType.SWAP_OWNER_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        swapOwnerSuccess: true,
        allMerchantUsers: state.allMerchantUsers
          ? {
              ...state.allMerchantUsers,
              outdated: true,
            }
          : null,
      };
    case UserManagementActionType.SWAP_OWNER_ROLE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        errorInfo: action.error,
        swapOwnerSuccess: false,
      };
    case UserManagementActionType.UPDATE_USER_ROLE:
      return {
        ...state,
        allMerchantUsers: state.allMerchantUsers
          ? {
              ...state.allMerchantUsers,
              data: state.allMerchantUsers.data.map(u => (u.id === action.userId ? { ...u, roles: [action.role] } : u)),
            }
          : null,
      };
    case UserManagementActionType.INVITE_USER:
      return {
        ...state,
        inviteLoading: true,
        inviteError: false,
        inviteErrorInfo: null,
      };
    case UserManagementActionType.INVITE_USER_SUCCESS:
      return {
        ...state,
        inviteLoading: false,
        inviteError: false,
        inviteErrorInfo: null,
      };
    case UserManagementActionType.INVITE_USER_ERROR:
      return {
        ...state,
        inviteLoading: false,
        inviteError: true,
        inviteErrorInfo: action.error,
      };
    case UserManagementActionType.RESEND_INVITE:
      return {
        ...state,
        loading: true,
        error: false,
        errorInfo: null,
        resendInviteSuccess: false,
      };
    case UserManagementActionType.RESEND_INVITE_SUCCESS:
      return {
        ...state,
        loading: false,
        resendInviteSuccess: true,
      };
    case UserManagementActionType.RESEND_INVITE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        errorInfo: action.error,
        resendInviteSuccess: false,
      };
    case UserManagementActionType.RESTORE_MERCHANT_USER:
      return {
        ...state,
        loading: true,
        error: false,
        errorInfo: null,
        restoreSuccess: false,
      };
    case UserManagementActionType.RESTORE_MERCHANT_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        restoreSuccess: true,
        allMerchantUsers: state.allMerchantUsers
          ? {
              ...state.allMerchantUsers,
              outdated: true,
            }
          : null,
      };
    case UserManagementActionType.RESTORE_MERCHANT_USER_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        errorInfo: action.error,
        restoreSuccess: false,
      };
    default:
      return state;
  }
};
